import { useEffect, useState } from "react";
import { FilterMapping } from "../../features/searchpage/constants/filters.constants";
import "./subject-filter.scss";
import { RadioButton, RadioButtonChangeEvent } from 'primereact/radiobutton';
import { SEARCH_API_CONSTANTS } from "../../constants/search.constanst";
import { postData } from "../../services/global.service";
import { APIEnv, APIStatus } from "../../interface/baseInterfaces";
import _ from "lodash";
import 'primereact/radiobutton/radiobutton.min.css';
import { isMobile } from "../../utils/globalUtilities";

const SubjectFilter = ({ tab, fieldKey, onChangeSubjectFilter, onChangeSubjectType, subjectText }: any) => {
  const [selectedSubjectList, setSelectedSubjectList] = useState<any>([]);
  const [unselectedSubjectList, setUnselectedSubjectList] = useState<any>([]);
  const [subjectList, setSubjectList] = useState<any>([]);
  const [backupSubjectList, setBackupSubjectList] = useState<any>([]);
  const [originalSubjectList, setOriginalSubjectList] = useState<any>([]);
  const [subjectSelected, setSubjectSelected] = useState<any>([]);
  const [selectedSubjectLabelArr, setSelectedSubjectLabelArr] = useState<any>([]);
  const [searchSubject, setSearchSubject] = useState<string>("");
  const [noResultFoundSearchSubject, setNoResultFoundSearchSubject] = useState<string>("");
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const [phraseOrAdvanceSearch, setPhraseOrAdvanceSearch] = useState<string>('p');
  const [position, setPosition] = useState<any>({});

  useEffect(() => {
    onChangeSubjectType(phraseOrAdvanceSearch)
  }, [phraseOrAdvanceSearch]);

  useEffect(() => {
    // if there is an already selected subject data then only rely on subject text to reset the subject selection
    if(subjectSelected?.length){
    if(subjectText?.length){
    }else{
      onSubjectClear()
    }
  }
  }, [subjectText]);

  const selectText = () => {
    const input: any = document.getElementById('text-box')
    input.focus()
    input.select()
  }

  const unselectText = () => {
    const input: any = document.getElementById('text-box')
    input.blur()
  }

  const onFocusSearch = () => {
    selectText();
  }

  const getDataAfterSearch = () => {
    setBackupSubjectList(subjectList);
    if (searchSubject.length == 0) {
      setShowDropDown(true);
      return
    } else if (searchSubject.length < 3) {
      return
    } else {
      setShowDropDown(true);
      getSubjectList();
    }
  }

  const getSubjectList = () => {
    let data = {
      "SearchText": searchSubject,
      "tabname": tab?.name ? tab.name : '',
      "Id": tab?.id ? tab.id : []
    };
    postData(SEARCH_API_CONSTANTS.SUBJECT_LIST,
      data,
      APIEnv.NODE_PREMIUM).then((response: any) => {
        if (response && response.ResponseType == APIStatus.SUCCESS) {
          if (response?.data?.date?.itemarray?.length) {
            setOriginalSubjectList(response.data.date.itemarray);
            let list: any = getSelectionFilter(subjectList, subjectSelected, response.data.date.itemarray);
            setSubjectList(list);
          } else {
            setOriginalSubjectList([]);
            let list = getSelectionFilter(subjectList, subjectSelected, originalSubjectList);
            setSubjectList(list);
          }
        } else {
          setOriginalSubjectList([]);
          let list = getSelectionFilter(subjectList, subjectSelected, originalSubjectList);
          setSubjectList(list);
        }
      }
      );
  }

  const getSelectionFilter = (list: any, filterValue: any, data: any[]) => {
    let res = [];
    if (filterValue?.length) {
      let isMultiple = Array.isArray(filterValue)
      filterValue = isMultiple ? filterValue : [filterValue]
      if (filterValue.length > 0) {
        let includes = manipulateData('I', filterValue, data);
        if (list?.length && list[0]?.value == '1') {
          let includesInList = manipulateData('I', filterValue, list[0].items);
          let valueIncludes = includes.map((a: any) => a.Id);
          let includesfinal = manipulateData('NI', valueIncludes, includesInList);
          includes = [...includes, ...includesfinal];
        }
        if (includes.length) {
          res.push({
            label: '',
            value: '1',
            items: includes,
          })
        }
        let excludes = manipulateData('NI', filterValue, data)
        if (excludes.length) {
          res.push({
            label: '',
            value: '0',
            items: excludes,
          })
        }
        return res;
      } else {
        let indexunselected = list.findIndex((data: any) => data.value == '0');
        if (indexunselected > -1) {
          list[indexunselected]['items'] = data;
        } else {
          res.push({
            label: '',
            value: '0',
            items: data,
          })
        }
        return res;
      }
    } else {
      res.push({
        label: '',
        value: '0',
        items: data,
      })
      return res;
    }
  }

  const manipulateData = (type: string, subsjectSelected: Array<any>, data: any) => {
    let arr = data;
    if (type === 'NI') {
      for (let data of subsjectSelected) {
        arr = arr.filter((res: { Id: string }) => res.Id !== data)
      }
      return arr
    } else if (type === 'I') {
      let res: any = [];
      for (let data of subsjectSelected) {
        res = _.concat(
          res,
          arr.filter((res: { Id: string }) => res.Id === data)
        )
      }
      return res
    }
    return arr
  }

  const onSubjectReset = () => {
    setSubjectSelected([]);
    setSelectedSubjectLabelArr([]);
    setSearchSubject('');
    setBackupSubjectList([]);
    setSubjectList([]);
  }

  const onSubjectChange = () => {
    // this.subjectValueChanged.emit(this.subjectSelected);
    onChangeSubjectFilter(selectedSubjectLabelArr);
    let list = getSelectionFilter(subjectList, subjectSelected, originalSubjectList);
    saveSubjectSelectedDetails(subjectSelected,selectedSubjectLabelArr,list, originalSubjectList, searchSubject);
    setSubjectList(list);
  }

  const onSubjectClear = () => {
    deleteSubjectSelectedDetails();
    setSubjectSelected([]);
    setSelectedSubjectLabelArr([]);
    setSearchSubject('');
    setBackupSubjectList([]);
    setSubjectList([]);
    setPhraseOrAdvanceSearch('p');
    onChangeSubjectType('p')
    onChangeSubjectFilter([]);
  }
  useEffect(()=>{
    getSubjectSelectedDetails();
  },[]);
  useEffect(()=>{
    if(subjectText.length==0)
      deleteSubjectSelectedDetails();
  },[subjectText]);
  const toggleSelection = (action: boolean, data: { Id: string, Name: string }) => {
    if (noResultFoundSearchSubject && (noResultFoundSearchSubject != searchSubject)) {
      // remove on result found serarch subject text if these not equal to current/entered serarch subject text
      if (selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
        selectedSubjectLabelArr.splice(selectedSubjectLabelArr.indexOf(noResultFoundSearchSubject), 1);
      }
    }
    if (action) {
      let listSeletion = subjectSelected;
      listSeletion.push(data.Id)
      setSubjectSelected(listSeletion);
      let listSubjectLabel = selectedSubjectLabelArr;
      listSubjectLabel.push(data.Name)
      setSelectedSubjectLabelArr(listSubjectLabel);
      onSubjectChange();
    } else {
      let index = subjectSelected.findIndex((value: any) => value == data.Id)
      if (index >= 0) {
        let listSeletion = subjectSelected;
        listSeletion.splice(index, 1);
        setSubjectSelected(listSeletion);
        // as pushing subecjt search text in label array, now subject id list and label list have diffrent indexes
        let indexLabel = selectedSubjectLabelArr.findIndex((value: any) => value == data.Name)
        if (indexLabel >= 0) {
          let listSubjectLabel = selectedSubjectLabelArr;
          listSubjectLabel.splice(indexLabel, 1);
          setSelectedSubjectLabelArr(listSubjectLabel);
        }
        onSubjectChange();
      }
    }
  }

  const enterSelection = () => {
    if (subjectList?.length && subjectList[0]?.items?.length > 0) {
      let data = subjectList[0].items[0];
      let text = searchSubject.trim();
      if (!subjectSelected.includes(data.Id)) {
        if (noResultFoundSearchSubject) {
          if (selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
            let selectedSubjectLabel = selectedSubjectLabelArr;
            let selectedSubjectIndex = selectedSubjectLabel.indexOf(noResultFoundSearchSubject);
            selectedSubjectLabel.splice(selectedSubjectIndex, 1);
            setSelectedSubjectLabelArr(selectedSubjectLabel)
          }
        }
        setNoResultFoundSearchSubject(text);
        let selectedSubjectLabel = selectedSubjectLabelArr;
        selectedSubjectLabel.push(text);
        setSelectedSubjectLabelArr(selectedSubjectLabel);
        onSubjectChange()
      } else if (subjectList?.length && subjectList[1]?.items && subjectList[1].items.length > 0) {
      } else {
        // pass no result found subject text in label array
        let text = searchSubject.trim();
        // allowed limit is 3 words
        if (text.length > 2) {
          // remove on result found serarch subject text before pushing  current/entered serarch subject text
          if (noResultFoundSearchSubject && selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
            let selectedSubjectLabel = selectedSubjectLabelArr;
            let selectedSubjectIndex = selectedSubjectLabel.indexOf(noResultFoundSearchSubject);
            selectedSubjectLabel.splice(selectedSubjectIndex, 1);
            setSelectedSubjectLabelArr(selectedSubjectLabel)
          }
          setNoResultFoundSearchSubject(text);
          let selectedSubjectLabel = selectedSubjectLabelArr;
          selectedSubjectLabel.push(text);
          setSelectedSubjectLabelArr(selectedSubjectLabel);
          onSubjectChange()
        } else {
          // remove on result found serarch subject text before pushing  current/entered serarch subject text
          if (noResultFoundSearchSubject && selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
            let selectedSubjectLabel = selectedSubjectLabelArr;
            let selectedSubjectIndex = selectedSubjectLabel.indexOf(noResultFoundSearchSubject);
            selectedSubjectLabel.splice(selectedSubjectIndex, 1);
            setSelectedSubjectLabelArr(selectedSubjectLabel)
          }
        }
      }
    } else {
      // pass no result found subject text in label array
      let text = searchSubject.trim();
      // allowed limit is 3 words
      if (text.length > 2) {
        if (noResultFoundSearchSubject) {
          if (selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
            let selectedSubjectLabel = selectedSubjectLabelArr;
            let selectedSubjectIndex = selectedSubjectLabel.indexOf(noResultFoundSearchSubject);
            selectedSubjectLabel.splice(selectedSubjectIndex, 1);
            setSelectedSubjectLabelArr(selectedSubjectLabel)
          }
        }
        setNoResultFoundSearchSubject(text);
        let selectedSubjectLabel = selectedSubjectLabelArr;
        selectedSubjectLabel.push(text);
        setSelectedSubjectLabelArr(selectedSubjectLabel);
        onSubjectChange()
      } else if (noResultFoundSearchSubject) {
        if (selectedSubjectLabelArr.includes(noResultFoundSearchSubject)) {
          let selectedSubjectLabel = selectedSubjectLabelArr;
          let selectedSubjectIndex = selectedSubjectLabel.indexOf(noResultFoundSearchSubject);
          selectedSubjectLabel.splice(selectedSubjectIndex, 1);
          setSelectedSubjectLabelArr(selectedSubjectLabel)
        }
        onSubjectChange()
      }
    }
  }

  function handle(e: any) {
    if (e.keyCode === 13) {
      enterSelection(); // Ensure it is only this code that runs
    }
  }

   const onClickMultiFieldSelection = (e: any) => {
        if (isMobile()) {
          let x = e.clientX;
          const screenportWidth = window.innerWidth;
          const scrWidthDrop = 200;
          if (x + scrWidthDrop > screenportWidth) {
            setPosition({ left: "auto", right: 0 });
          }
          else if (x < scrWidthDrop / 2) {
            setPosition({ left: 0, right: "auto" });
          }
          else {
            setPosition({ left: x - scrWidthDrop / 2, right: "auto" });
          }
    }
    }
    const saveSubjectSelectedDetails = (subjectSelected: any, selectedSubjectLabelArr: any, subjectList: any , originalSubjectList :any, searchSubject:any) => {
      localStorage.setItem('subjectSelected', JSON.stringify(subjectSelected));
      localStorage.setItem('selectedSubjectLabelArr', JSON.stringify(selectedSubjectLabelArr));
      localStorage.setItem('subjectList', JSON.stringify(subjectList));
      localStorage.setItem('originalSubjectList', JSON.stringify(originalSubjectList));
      localStorage.setItem('searchSubject', JSON.stringify(searchSubject));
    };    
    const getSubjectSelectedDetails = () => {
      const storedSubjects = JSON.parse(localStorage.getItem('subjectSelected') || '[]');
      const storedLabels = JSON.parse(localStorage.getItem('selectedSubjectLabelArr') || '[]');
      const storedList = JSON.parse(localStorage.getItem('subjectList') || '[]');
      const storedOriginalSubjectList = JSON.parse(localStorage.getItem('originalSubjectList')||'[]');
      const storedSearchSubject = JSON.parse(localStorage.getItem('searchSubject') || '""');
      setSubjectSelected(storedSubjects);
      setSelectedSubjectLabelArr(storedLabels);
      setSubjectList(storedList);
      setOriginalSubjectList(storedOriginalSubjectList);
      setSearchSubject(storedSearchSubject);
    };
    const deleteSubjectSelectedDetails = () => {
      localStorage.removeItem('subjectSelected');
      localStorage.removeItem('selectedSubjectLabelArr');
      localStorage.removeItem('subjectList');
      localStorage.removeItem('originalSubjectList');
      localStorage.removeItem('searchSubject');
    };  
  return (
    <li key={fieldKey} className="dropdowns ui-filter-item auto-dropdowns subject-dropdowns-1">
      <a  className={`dropdown-toggle-2 cursor-pointer ${subjectText.length!=0 ? 'active' : ''} `}  onClick={(e) => { onClickMultiFieldSelection(e) }} >
        {FilterMapping[fieldKey]['label']}
      </a>
      <span className="dropdown-contents" style={{ left: position.left, right: position.right, width: "200px", }} >

        <span className="dropdown-search">
          <input value={searchSubject} id="text-box" type="search" placeholder="Search" onMouseOver={() => selectText()} onMouseOut={() => unselectText()} onFocus={() => onFocusSearch()}
            onKeyUp={() => getDataAfterSearch()} onChange={(e) => setSearchSubject(e.target.value)} onKeyPress={(e) => handle(e)} />
        </span>

        {
          subjectList?.length ?
            subjectList?.map((group: any, groupindex:number) => (
              <ul key={`group${groupindex}`} className="auto-dropdown-items">
                {
                  group?.value == '1' ?
                    group?.items?.length ?
                      group?.items.map((item: any) => (
                        <li
                          key={item.Id} onClick={() => toggleSelection(false, item)}
                        >
                          <span className="checkbox-ui">
                            <input type="checkbox" checked />
                          </span>
                          {item.Name}
                        </li>
                      )
                      )
                      : ''
                    :
                    group?.value == '0' ?
                      group?.items?.length ?
                        group?.items.map((item: any) => (
                          <li
                            key={item.Id} onClick={() => toggleSelection(true, item)}
                          >
                            <span className="checkbox-ui">
                              <input type="checkbox" />
                            </span>
                            {item.Name}
                          </li>
                        )
                        )
                        : ''
                      : ''
                }
              </ul>
            ))
            : ''
        }
        <div className="p-radio-rows">
          <span className="p-radios">
            <RadioButton inputId="phrase" name="phraseoradvance" value="p" onChange={(e: RadioButtonChangeEvent) => {setPhraseOrAdvanceSearch(e.value) } }
            checked={phraseOrAdvanceSearch == 'p'} />
            <label htmlFor="phrase" >Phrase Search</label>
            
          </span>
          <span className="p-radios">
            <RadioButton inputId="advance" name="phraseoradvance" value="a" onChange={(e: RadioButtonChangeEvent) => {setPhraseOrAdvanceSearch(e.value) } } 
            checked={phraseOrAdvanceSearch == 'a'} />
            <label htmlFor="advance" >Advance Search</label>
          </span>
        </div>
        <div className="button-clear-selection">
          <a
            className="cursor-pointer"
            onClick={()=> onSubjectClear()}
          >Clear Selection</a>
        </div>
      </span>
    </li>
  );
};

export default SubjectFilter;
